import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import ChatPanel from './components/ChatPanel';
import SystemChatPanel from './components/SystemChatPanel';
import TechnicianPortal from './pages/TechnicianPortal';
import WifiManagement from './components/WifiManagement';
import WifiVerify from './components/WifiVerify';
import WifiAdminPanel from './components/WifiAdminPanel';
import BackupPanel from './components/BackupPanel';
import MantenidosPanel from './components/MantenidosPanel';
import InvoiceViewer from './components/InvoiceViewer';
import SuspendedClientsPanel from './components/SuspendedClientsPanel';
import PagosPage from './pages/PagosPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/technician" element={<TechnicianPortal />} />
            <Route path="/wifi/:token" element={<WifiManagement />} />
            <Route path="/cliente/:token" element={<WifiManagement />} />
            <Route path="/wifi/verify" element={<WifiVerify />} />
            <Route path="/cliente/verify" element={<WifiVerify />} />
            <Route path="/factura" element={<InvoiceViewer />} />
            <Route
              path="/pagos"
              element={
                <PrivateRoute>
                  <PagosPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/wifi"
              element={
                <PrivateRoute>
                  <WifiAdminPanel />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/backups"
              element={
                <PrivateRoute>
                  <BackupPanel />
                </PrivateRoute>
              }
            />
            <Route path="/mantenidos" element={<PrivateRoute><MantenidosPanel /></PrivateRoute>} />
            <Route
              path="/admin/suspended"
              element={<SuspendedClientsPanel />}
            />
            <Route
              path="/system-messages"
              element={
                <PrivateRoute>
                  <SystemChatPanel />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <ChatPanel />
                </PrivateRoute>
              }
            />
            <Route
              path="/:chatId"
              element={
                <PrivateRoute>
                  <ChatPanel />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
